var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5",attrs:{"id":"loading"}},[_c('h1',[_vm._v("Error")]),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }